var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"title":("Заказ #" + _vm.orderId)}},[_c('breadcrumbs',{attrs:{"crumbs":_vm.crumbs}}),(_vm.isOrderFetched)?_c('order-view',{attrs:{"order":_vm.order}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }